<template>
  <div class="container">
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="disabledPull"
      @refresh="onRefresh"
    >
      <div class="page pb_24" :class="{ pt_120: info.banner }">
        <div class="page_header">
          <img
            v-if="info.banner"
            class="page_banner"
            :src="info.banner"
          />
        </div>
        <div class="page_desc box_wrap z_index_1">
          <div class="page_desc_title box_header">
            <img style="height: 24px;" :src="`${CDN_URL}/title2.png`" />
          </div>
          <div class="page_desc_content box_ctx">
            <div class="page_desc_item">
              <div class="page_desc_icon">TIP1</div>
              <div class="page_desc_label">活动介绍</div>
              <div class="page_desc_value">{{ info.introduce }}</div>
            </div>
            <div class="page_desc_item">
              <div class="page_desc_icon">TIP2</div>
              <div class="page_desc_label">活动时间</div>
              <div class="page_desc_value">{{ info.timeDesc }}</div>
            </div>
            <div class="page_desc_item">
              <div class="page_desc_icon">TIP3</div>
              <div class="page_desc_label">奖励领取</div>
              <div class="page_desc_value">{{ info.rewardDesc }}</div>
            </div>
            <!-- 游戏下载区 -->
            <div class="game_download mt_24">
              <div class="game_download_title">
                <img :src="`${CDN_URL}/title3.png`" />
              </div>
              <div class="game_item van-hairline--bottom">
                <div
                  class="game_icon bg_contain"
                  :style="{
                    backgroundImage: `url(${gameInfo.icon})`
                  }"
                ></div>
                <div class="game_desc">
                  <div class="game_name">{{ gameInfo.gameName }}</div>
                  <div class="game_tags scale08">
                    <div
                      v-for="(tag, tIdx) in gameInfo.tags"
                      :key="tIdx"
                      class="game_tag fs_12"
                      :style="{
                        border: `1px solid ${tag.labelInfo || '#000'}`,
                        color: tag.labelInfo
                      }"
                    >
                      {{ tag.labelName }}
                    </div>
                  </div>
                  <div class="game_extra fs_12 scale08_bot">
                    <div class="game_score van-hairline--right">{{ gameInfo.score }}分</div>
                    <div class="game_verson">{{ gameInfo.version }}版本</div>
                  </div>
                </div>
                <div
                  class="game_btn"
                  style="background: linear-gradient(102deg,#ff401d 0%, #ff5e8a 100%), #5828dc;"
                  @click="handleClickDownload"
                >
                  下载体验
                </div>
              </div>
            </div>
            <!-- 礼包群 -->
            <div class="page_gifts_title mt_10 mb_6">
              <img style="height: 29px;" :src="`${CDN_URL}/title4.png`" />
            </div>
            <div class="page_gifts_wrap">
              <div class="page_gifts">
                <div
                  v-for="gift in giftList"
                  :key="gift.giftGameId"
                  class="gift_item"
                >
                  <div class="gift_tag">
                    <template v-if="gift.rewardType === 1">
                      <div style="display: flex; align-items: center;">
                        <img style="height: 14px; margin-right: 6px;" :src="gameInfo.icon" />
                        <p>{{ gameInfo.gameName }}</p>
                      </div>
                    </template>
                    <template v-else>
                      全平台通用
                    </template>
                  </div>
                  <div
                    class="gift_icon bg_contain"
                    :style="{
                      backgroundImage: `url(${gift.rewardIcon})`
                    }"
                  >
                  </div>
                  <div class="gift_ctx fs_12 mb_14" style="color: #72350B; line-height: 15px; flex: 1">
                    福利内容: {{ getGiftCtx(gift) }}
                  </div>
                  <div
                    class="gift_btn"
                    :class="{ disabled: [2, 3].includes(gift.drawStatus) }"
                    @click="receiveGift(gift)"
                  >
                    {{ drawStatusMap[gift.drawStatus] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PullRefresh>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      :headerStyle="{
        background: '#5828DC'
      }"
      cancelButtonColor="#9d9d9d"
      confirmButtonColor="#5828DC"
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >

    </ActivityPopup>
  </div>
</template>

<script>
import { 
  getGamePlaceApi,
  receiveGameTesterGiftApi,
} from '@/apis/btBoxActivity' 
import { PullRefresh } from "vant";
import ActivityPopup from '@/components/btBox/ActivityPopup.vue';
import EventTrack from '@/mixins/eventTrack'
import { setPageTitle, jumpToNative } from "@/bridge/AppJsBridge";
import { CDN_URL_1 } from "@/config";

const rewardTypeMapFeedback = {
  1: { type: 3, name: '礼包' },
  2: { type: 4, name: '积分' },
  3: { type: 5, name: '代金券' },
}
export default {
  components: {
    PullRefresh,
    ActivityPopup,
  },
  mixins: [EventTrack],
  beforeCreate () {
    this.skipInit = !!(this.$route.query.fromHome) || false
  },
  data () {
    return {
      CDN_URL: CDN_URL_1 + '/box_bt_game_tester',
      visible: false,
      feedbackType: 0,
      disabledPull: false,
      isLoading: true,
      submitLoading: false,
      isFirstSucc: false, // 当前弹框是否是第一次请求接口调起的
      info: {},
      curGift: {},
      drawStatusMap: {
        1: '领取',
        2: '已领取',
        3: '已失效',
      },
    }
  },
  computed: {
    gameInfo () {
      return this.info.gameInfoVo || {}
    },
    giftList () {
      return this.info.activityGiftVoList || []
    },
    gameId () {
      return this.$route.query.activityGameId
    },
    // 这里的键名对应 popup 的 props
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '确认领取',
          message: [
            `领取福利后,`,
            '该游戏会场的其他福利将失效,',
            '确认领取吗?'
          ],
          confirmButtonText: '确认领取',
          cancelButtonText: '再看看',
          showCancelButton: true,
          onSure: () => {
            this.triggerVisible(false)
            this.goReceive(this.curGift)
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        {
          title: '不满足领取条件',
          message: [
            '未检测到创角记录,',
            `下载《${this.gameInfo.gameName}》创角后`,
            '即可领取抽奖机会'
          ],
          showCancelButton: false,
          confirmButtonText: '下载游戏',
          onSure: () => {
            const { activityGiftId, rewardType } = this.curGift
            this.triggerVisible(false)
            this.eventTrack({
              event: 'taste_activity_draw_dowd_game',
              event_field: JSON.stringify({
                ...this.trackActInfo,
                reward_id: activityGiftId,
                reward_type: rewardType,
              }),
              ...this.trackGameInfo
            })
            this.handleGoDownload()
          },
          onCancel: () => {
          },
        },
        {
          title: '不满足领取条件',
          message: [
            `您在《${this.gameInfo.gameName}》中已有历史创角,`,
            '去其他游戏会场看看吧~'
          ],
          showCancelButton: false,
          confirmButtonText: '我知道了',
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {},
        },
        {
          title: '领取成功',
          message: [
            '礼包码已存放在',
            '【我的】-【我的礼包】-【活动礼包】'
          ],
          showCancelButton: true,
          confirmButtonText: '查看礼包码',
          cancelButtonText: '再看看',
          onSure: () => {
            this.handleTrackBeforeLeave()
            this.handleGoGift()
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        {
          title: '领取成功',
          message: [
            `账户积分+${this.curGift.rewardObj}`
          ],
          showCancelButton: true,
          confirmButtonText: '去使用积分',
          cancelButtonText: '再看看',
          onSure: () => {
            this.handleTrackBeforeLeave()
            this.triggerVisible(false)
            this.handleGoPointsMall()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        {
          title: '领取成功',
          message: [
            '代金券已存放在',
            '【我的】-【代金券】'
          ],
          showCancelButton: true,
          confirmButtonText: '查看代金券',
          cancelButtonText: '再看看',
          onSure: () => {
            this.handleTrackBeforeLeave()
            this.triggerVisible(false)
            this.handleGoVoucher()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
      ]
    },
    trackGameInfo () {
      return {
        appkey: this.gameInfo.gameId,
        appName: this.gameInfo.gameName,
      }
    },
    trackActInfo () {
      return {
        activity_id: this.info.activityId,
        activity_name: this.info.name,
      }
    },
  },
  mounted () {
    this.getAppToken(true)
  },
  activated () {
    this.init()
    setPageTitle(this.info.title)
  },
  methods: {
    getActivityInfo () {
      this.init()
    },
    init () {
      return this.getInfo().then(res => {
        setPageTitle(this.info.name)
        this.eventTrack({
          event: 'taste_activity_game_place_page',
          event_field: JSON.stringify(this.trackActInfo),
          ...this.trackGameInfo,
        })
      })
    },
    onRefresh () {
      this.init().then(res => {
        this.isLoading = false
      })
    },
    getInfo () {
      return getGamePlaceApi({
        activityGameId: this.gameId,
      }).then(res => {
        this.info = res.data || {}
      })
    },
    // 能否领取标记在 info 接口返回了
    receiveGift (gift) {
      this.curGift = gift
      const { drawStatus, rewardType, activityGiftId } = gift
      if (drawStatus === 3) return
      if (drawStatus === 2) {
        this.triggerVisible(true, rewardTypeMapFeedback[rewardType]?.type)
        return
      }
      this.eventTrack({
        event: 'taste_activity_draw_reward',
        event_field: JSON.stringify({
          ...this.trackActInfo,
          reward_id: activityGiftId,
          reward_type: rewardType,
        }),
        ...this.trackGameInfo,
      })
      const { conditStatus } = this.info
      this.triggerVisible(true, conditStatus)
      const event_name = conditStatus === 0 ? 'taste_activity_affirm_draw_pop' : 'taste_activity_dissatisfy_draw_condit_pop'
      this.eventTrack({
        event: event_name,
        event_field: JSON.stringify({
          ...this.trackActInfo,
          reward_id: activityGiftId,
          reward_type: rewardType,
          type: conditStatus === 1 ? 2 : 1, // 有无创角
        }),
        ...this.trackGameInfo,
      })
    },
    goReceive (gift) {
      if (this.submitLoading) return
      const { activityGiftId, rewardType } = gift

      this.eventTrack({
        event: 'taste_activity_affirm_draw_button',
        event_field: JSON.stringify({
          ...this.trackActInfo,
          reward_id: activityGiftId,
          reward_type: rewardType,
        }),
        ...this.trackGameInfo,
      })

      this.submitLoading = true
      receiveGameTesterGiftApi({
        activityGameId: this.gameId,
        activityGiftId: activityGiftId
      }).then(res => {
        const { cdk } = res.data
        if (rewardType === 1 && !cdk) {
          this.$toast.fail('礼包已被领完，试试领取其他福利吧')
        } else {

          this.eventTrack({
            event: 'taste_activity_draw_success_pop',
            event_field: JSON.stringify({
              ...this.trackActInfo,
              reward_id: activityGiftId,
              reward_type: rewardType,
            }),
            ...this.trackGameInfo,
          })

          this.$toast.success(rewardTypeMapFeedback[rewardType].name + '领取成功')
          this.triggerVisible(true, rewardTypeMapFeedback[rewardType]?.type, true)
          this.init()
        }
      }).catch(err => {
      }).finally(() => {
        this.submitLoading = false
      })
    },
    // isFirstSucc -> 是否是第一次接口返回触发的弹框
    triggerVisible (v, type, isFirstSucc = false) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.isFirstSucc = isFirstSucc
      this.visible = v
    },
    getGiftCtx (gift = {}) {
      const { voucherName, rewardType, rewardObj, giftDecs } = gift
      const map = {
        1: giftDecs,
        2: rewardObj + '积分',
        3: voucherName,
      }
      return map[rewardType] || ''
    },
    handleClickDownload () {
      this.eventTrack({
        event: 'taste_activity_down_game_button',
        event_field: JSON.stringify(this.trackActInfo),
        ...this.trackGameInfo,
      })
      this.handleGoDownload()
    },
    // 跳转游戏下载
    handleGoDownload () {
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: this.gameInfo.gameId,
        fromPageType: 26, // 未标记资源位
      }
      const dataStr = JSON.stringify(data)
      jumpToNative(dataStr)
    },
    handleGoGift () {
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 2, // 2 -> BT盒子活动 3-> 玩心盒子活动
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr)
    },
    // 跳转积分商城
    handleGoPointsMall () {
      const data = {
        routePath: "/task/CreditStoreActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 跳转代金券
    handleGoVoucher () {
      const data = {
        routePath: "/coupon/CouponManageActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 离开本 h5 之前的埋点
    handleTrackBeforeLeave () {
      if (!this.isFirstSucc) return
      const { activityGiftId, rewardType } = this.curGift
      this.eventTrack({
        event: 'taste_activity_reward_view_button',
        event_field: JSON.stringify({
          ...this.trackActInfo,
          reward_id: activityGiftId,
          reward_type: rewardType,
        }),
        ...this.trackGameInfo,
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "./style.scss";
.page_gifts {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.game_download {
  background: linear-gradient(180deg,#d7e7ff 0%, #dde9ff 100%), #eef0fd;
  border-radius: 12px;
  padding: 8px;
  .game_download_title {
    padding-top: 2px;
    padding-left: 8px;
    img {
      height: 20px;
    }
  }
}
.gift_item {
  position: relative;
  padding: 32px 12px 14px;
  width: 154px;
  background: #d9e8ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  margin-bottom: 12px;
  .gift_icon {
    width: 56px;
    height: 56px;
    margin-bottom: 14px;
  }
  .gift_tag {
    position: absolute;
    left: 0;
    top: 8px;
    padding: 4px 16px 3px 8px;
    color: #5F0304;
    font-size: 14px;
    background: linear-gradient(90deg, #ecf4ff 80%, transparent 100%);
  }
  .gift_btn {
    text-align: center;
    width: 86px;
    flex-shrink: 0;
    padding: 10px;
    font-size: 12px;
    color: #fff;
    background-color: #5828DC;
    border-radius: 40px;
  }
  .gift_btn.disabled {
    background-color: #9d9d9d;
  }
}
</style>